import clsx from "clsx";

export const RowHeaderColDef = {
    field: "rowHeader",
    headerName: "Original Line Item",
    colId: "rowHeader",
    minWidth: 260,
    suppressHeaderMenuButton: true,
    sortable: false,
    resizable: false,
    valueGetter: (params) => {
        return params.data.rowHeader;
    },
};

export const RowHeaderCellRenderer = ({
    rowHeader,
    isDisabled,
}: {
    rowHeader?: string | null;
    isDisabled: boolean;
}) => {
    if (!rowHeader)
        return (
            <div
                className={clsx(
                    "size-full",
                    isDisabled ? "cursor-default" : "cursor-pointer",
                )}
            />
        );

    return (
        <div
            className={clsx(
                "size-full",
                !isDisabled ? "opacity-100" : "opacity-50",
                isDisabled ? "cursor-default" : "cursor-pointer",
            )}
        >
            {rowHeader}
        </div>
    );
};
